import { escapeHtml } from './grcUtils';

function fieldValue(value) {
  const text = String(value || '').trim();
  if (!text) return '<span class="grc-blank"></span>';
  return `<span class="grc-filled">${escapeHtml(text)}</span>`;
}

function field(label, value, extraClass = '') {
  return `
    <div class="grc-field${extraClass ? ` ${extraClass}` : ''}">
      <span class="grc-label">${escapeHtml(label)}</span>
      ${fieldValue(value)}
    </div>
  `;
}

function checkbox(label, checked) {
  return `
    <span class="grc-check${checked ? ' is-on' : ''}">
      <span class="grc-box">${checked ? '✓' : ''}</span>
      <span class="grc-check-label">${escapeHtml(label)}</span>
    </span>
  `;
}

function icon(name) {
  const icons = {
    login: '<path d="M10 3h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4"/><path d="M3 10h9"/><path d="M8 7l3 3-3 3"/>',
    logout: '<path d="M6 3h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6"/><path d="M13 10H4"/><path d="M7 7l-3 3 3 3"/>',
    bed: '<path d="M2 12v3M14 12v3M2 10h12a3 3 0 0 0 3-3V6H8a3 3 0 0 0-3 3v1H2z"/>',
    door: '<path d="M4 15V3h8v12"/><path d="M3 15h12"/><path d="M10 8.5h.01"/>',
    moon: '<path d="M13 11.5A5.5 5.5 0 0 1 6.5 5 6 6 0 1 0 13 12.5V11.5z"/>',
    guests: '<path d="M8 8a2.2 2.2 0 1 0 0-4.4A2.2 2.2 0 0 0 8 8z"/><path d="M3.5 14c.4-2 2.2-3.3 4.5-3.3s4.1 1.3 4.5 3.3"/>',
  };
  return `<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${icons[name] || ''}</svg>`;
}

function stayCard(kind, label, date, time) {
  return `
    <div class="grc-stay-card ${kind === 'in' ? 'is-in' : 'is-out'}">
      <div class="grc-stay-kicker">${icon(kind === 'in' ? 'login' : 'logout')}${escapeHtml(label)}</div>
      <div class="grc-stay-date">${escapeHtml(date || '—')}</div>
      <div class="grc-stay-time">${escapeHtml(time || '')}</div>
    </div>
  `;
}

function stayPill(iconName, value) {
  if (!value) return '';
  return `<div class="grc-pill">${icon(iconName)}<span>${escapeHtml(value)}</span></div>`;
}

function payRow(label, value, { strong = false } = {}) {
  return `
    <tr class="${strong ? 'is-total' : ''}">
      <td>${escapeHtml(label)}</td>
      <td>${escapeHtml(value || '—')}</td>
    </tr>
  `;
}

const GRC_STYLE_ID = 'grc-card-styles';

export function getGuestRegistrationCardStyles() {
  return `
    .grc-page,
    .grc-sheet {
      --grc-ink: #16332d;
      --grc-muted: #5b6d68;
      --grc-line: #c9d4cf;
      --grc-fill: #e7f6f0;
      --grc-accent: #1b6b5a;
      --grc-gold: #c4a35a;
      --grc-paper: #fffdf8;
      color-scheme: only light;
      forced-color-adjust: none;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      background-image: none !important;
    }
    .grc-sheet {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      background: var(--grc-paper);
      background-image: none !important;
      color: var(--grc-ink);
      font-family: "Segoe UI", Helvetica, Arial, sans-serif;
      border: 1px solid #d7cbb3;
    }
    .grc-sheet *, .grc-sheet *::before, .grc-sheet *::after { box-sizing: border-box; }
    .grc-topbar {
      height: 5px;
      background: #134e43;
    }
    .grc-header {
      display: grid;
      grid-template-columns: 88px 1fr auto;
      gap: 14px;
      align-items: center;
      padding: 14px 16px 12px;
    }
    .grc-logo-wrap {
      width: 88px;
      height: 88px;
      border-radius: 12px;
      border: 1px solid #e4d8be;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    .grc-logo-wrap img { max-width: 80px; max-height: 80px; object-fit: contain; }
    .grc-logo-fallback {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #134e43;
      color: #fff;
      -webkit-text-fill-color: #fff;
      font-weight: 800;
      font-size: 22px;
    }
    .grc-sheet .grc-hotel-name,
    .grc-page .grc-hotel-name {
      margin: 0;
      font-size: 22px;
      line-height: 1.15;
      font-weight: 800;
      color: #11382f !important;
      -webkit-text-fill-color: #11382f !important;
    }
    .grc-tagline {
      margin: 4px 0 6px;
      font-size: 10px;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: var(--grc-gold);
      font-weight: 700;
    }
    .grc-hotel-meta, .grc-refs {
      font-size: 10px;
      line-height: 1.4;
      color: var(--grc-muted);
    }
    .grc-refs { text-align: right; min-width: 148px; }
    .grc-refs strong { color: var(--grc-ink); font-weight: 700; font-size: 12px; }
    .grc-title {
      margin: 0;
      padding: 8px 12px;
      text-align: center;
      letter-spacing: 0.16em;
      font-size: 13px;
      font-weight: 800;
      color: #11382f;
      -webkit-text-fill-color: #11382f;
      background: #e8f5ef;
      border-top: 2px solid #134e43;
      border-bottom: 2px solid #134e43;
    }
    .grc-stayband {
      display: grid;
      grid-template-columns: minmax(120px, 0.9fr) minmax(180px, 1.6fr) minmax(120px, 0.9fr);
      gap: 8px;
      align-items: stretch;
      margin: 0;
      padding: 10px 12px;
      background: #e8f5ef;
      border-bottom: 1px solid #d4e6de;
      overflow: visible;
    }
    .grc-stay-card {
      background: #fff;
      border-radius: 12px;
      border: 1px solid #d4e6de;
      box-shadow: none;
      padding: 8px 10px 8px;
      min-width: 0;
    }
    .grc-stay-card.is-in { border-top: 3px solid #134e43; }
    .grc-stay-card.is-out { border-top: 3px solid #c4a35a; }
    .grc-stay-kicker {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 8.5px;
      font-weight: 800;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      margin-bottom: 3px;
    }
    .grc-stay-card.is-in .grc-stay-kicker { color: #134e43; }
    .grc-stay-card.is-out .grc-stay-kicker { color: #b08a3a; }
    .grc-stay-date {
      font-size: 15px;
      font-weight: 800;
      line-height: 1.15;
      color: #11382f;
      -webkit-text-fill-color: #11382f;
    }
    .grc-stay-time {
      margin-top: 2px;
      font-size: 10px;
      font-weight: 600;
      color: #6d7f79;
    }
    .grc-stay-pills {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 6px;
      align-content: center;
      min-width: 0;
    }
    .grc-pill {
      display: flex;
      align-items: center;
      gap: 5px;
      min-width: 0;
      background: #fff;
      border-radius: 10px;
      border: 1px solid #d4e6de;
      box-shadow: none;
      padding: 6px 8px;
      font-size: 9.5px;
      font-weight: 700;
      color: #11382f;
      -webkit-text-fill-color: #11382f;
    }
    .grc-pill svg, .grc-stay-kicker svg {
      flex-shrink: 0;
      width: 12px;
      height: 12px;
    }
    .grc-pill span {
      flex: 1 1 auto;
      min-width: 0;
      overflow: visible;
      white-space: normal;
      word-break: break-word;
      line-height: 1.25;
    }
    .grc-body {
      flex: 1 1 auto;
      min-height: 0;
      display: flex;
      flex-direction: column;
      padding: 12px 14px 10px;
    }
    .grc-grow { flex: 1 1 auto; min-height: 6px; }
    .grc-bottom { flex: 0 0 auto; }
    .grc-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 10px 14px;
    }
    .grc-field { min-width: 0; }
    .grc-span-2 { grid-column: span 2; }
    .grc-span-3 { grid-column: 1 / -1; }
    .grc-label {
      display: block;
      font-size: 8px;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: #6d7f79;
      margin-bottom: 3px;
    }
    .grc-filled {
      display: block;
      min-height: 28px;
      padding: 5px 7px;
      border-bottom: 1px solid #9cc9ba;
      background: var(--grc-fill);
      color: #0f3c33;
      font-size: 11px;
      font-weight: 700;
      line-height: 1.35;
      word-break: break-word;
    }
    .grc-blank {
      display: block;
      min-height: 28px;
      border-bottom: 1px dotted #9aa8a3;
    }
    .grc-split {
      display: grid;
      grid-template-columns: 1.35fr 0.95fr;
      gap: 12px;
      margin-top: 12px;
    }
    .grc-section {
      margin: 0 0 4px;
      font-size: 8.5px;
      font-weight: 800;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: var(--grc-accent);
      border-bottom: 1px solid #d7e6e0;
      padding-bottom: 2px;
    }
    .grc-pay {
      width: 100%;
      border-collapse: collapse;
      font-size: 10.5px;
      background: #fff;
    }
    .grc-pay th {
      background: #e8f5ef;
      color: #11382f;
      -webkit-text-fill-color: #11382f;
      font-size: 10px;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      font-weight: 800;
      padding: 6px 7px;
      text-align: left;
      border-bottom: 2px solid #134e43;
    }
    .grc-pay td {
      border-bottom: 1px solid #e4ece8;
      padding: 3px 7px;
    }
    .grc-pay td:last-child {
      text-align: right;
      font-weight: 700;
      white-space: nowrap;
    }
    .grc-pay tr.is-total td {
      background: var(--grc-fill);
      font-weight: 800;
      border-top: 1px solid #9cc9ba;
    }
    .grc-checks {
      display: flex;
      flex-wrap: wrap;
      gap: 7px 16px;
      padding: 6px 0 0;
    }
    .grc-check {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex: 0 0 calc(50% - 8px);
      min-width: 0;
      font-size: 10.5px;
      font-weight: 600;
      color: #16332d;
      line-height: 1.2;
    }
    .grc-check-label {
      white-space: nowrap;
    }
    .grc-box {
      flex: 0 0 12px;
      width: 12px;
      height: 12px;
      border: 1px solid #7d8f89;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 8px;
      background: #fff;
    }
    .grc-check.is-on .grc-box {
      background: var(--grc-accent);
      border-color: var(--grc-accent);
      color: #fff;
      -webkit-text-fill-color: #fff;
    }
    .grc-policy {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      gap: 12px;
      margin-top: 8px;
      padding: 8px 10px;
      background: #fff;
      border: 1px solid var(--grc-line);
      font-size: 10px;
    }
    .grc-policy-copy {
      flex: 1 1 auto;
      min-width: 0;
    }
    .grc-policy-times { font-weight: 800; color: var(--grc-accent); }
    .grc-note {
      margin: 6px 0 0;
      padding-top: 6px;
      border-top: 1px solid #c4b89a;
      font-size: 9.5px;
      line-height: 1.45;
      letter-spacing: 0.01em;
      word-spacing: 0.04em;
      color: #5c5c5c;
      width: 100%;
    }
    .grc-sign {
      flex: 0 0 180px;
      width: 180px;
      text-align: left;
      padding: 6px 8px;
      border: 1px dashed #9aa8a3;
      background: #fffef9;
    }
    .grc-sign .grc-blank { min-height: 52px; border-bottom: none; }
    .grc-footer {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      margin-top: 6px;
    }
    .grc-sig-line {
      margin-top: 18px;
      border-top: 1px solid #8ea39c;
      padding-top: 3px;
      font-size: 9px;
      color: var(--grc-muted);
    }
    .grc-fine {
      margin-top: 4px;
      font-size: 8px;
      color: #7b8a85;
      display: flex;
      justify-content: space-between;
      gap: 8px;
    }
    .grc-page {
      box-sizing: border-box;
      padding: 20px;
      background: #fffdf8;
      background-image: none !important;
      color: #16332d;
      display: flex;
      flex-direction: column;
    }
    .grc-page .grc-sheet {
      width: 100%;
      height: 100%;
      max-width: none;
      aspect-ratio: auto;
    }
    .grc-print-root,
    .grc-print-root body {
      width: 210mm;
      height: 297mm;
      margin: 0;
      padding: 0;
      overflow: hidden;
      background: #fffdf8;
      color: #16332d;
      color-scheme: only light;
    }
    .grc-print-root .grc-page {
      width: 210mm;
      height: 297mm;
      overflow: hidden;
    }
    @media print {
      .grc-print-root,
      .grc-print-root body,
      .grc-print-root .grc-page,
      .grc-print-root .grc-sheet {
        box-shadow: none;
        background-image: none !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        page-break-inside: avoid;
        break-inside: avoid;
        page-break-after: avoid;
      }
    }
  `;
}

export function renderGuestRegistrationCardMarkup(data = {}) {
  const initials = String(data.hotelName || 'HOTEL')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

  const logo = data.hotelLogoUrl
    ? `<img src="${escapeHtml(data.hotelLogoUrl)}" alt="${escapeHtml(data.hotelName || 'Hotel logo')}" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" /><div class="grc-logo-fallback" style="display:none">${escapeHtml(initials || 'H')}</div>`
    : `<div class="grc-logo-fallback">${escapeHtml(initials || 'H')}</div>`;

  const contactBits = [
    data.hotelGstin ? `GSTIN: ${data.hotelGstin}` : '',
    data.hotelAddress,
    [data.hotelPhone ? `Tel: ${data.hotelPhone}` : '', data.hotelEmail].filter(Boolean).join('  ·  '),
  ].filter(Boolean);

  const nightsLabel = data.nights
    ? `${data.nights} night${Number(data.nights) === 1 ? '' : 's'}`
    : '';
  const guestsLabel = data.persons
    ? `${data.persons} guest${Number(data.persons) === 1 ? '' : 's'}`
    : '';
  const roomLabel = data.roomNo ? `Room ${data.roomNo}` : '';
  const stayPills = [
    stayPill('bed', data.roomType),
    stayPill('door', roomLabel),
    stayPill('moon', nightsLabel),
    stayPill('guests', guestsLabel),
  ].join('');

  return `
    <article class="grc-sheet">
      <div class="grc-topbar"></div>
      <header class="grc-header">
        <div class="grc-logo-wrap">${logo}</div>
        <div>
          <p class="grc-hotel-name">${escapeHtml(data.hotelName || 'Hotel')}</p>
          ${data.hotelTagline ? `<p class="grc-tagline">${escapeHtml(data.hotelTagline)}</p>` : ''}
          <div class="grc-hotel-meta">${contactBits.map((bit) => escapeHtml(bit)).join('<br />')}</div>
        </div>
        <div class="grc-refs">
          <div>GR Card No.<br /><strong>${escapeHtml(data.grCardNo || '—')}</strong></div>
          <div style="margin-top:4px">Bill No.<br />${fieldValue(data.billNo)}</div>
        </div>
      </header>
      <div class="grc-title">GUEST REGISTRATION CARD</div>
      <div class="grc-stayband">
        ${stayCard('in', 'Check-in', data.checkInDate, data.checkInTime || data.checkInPolicy)}
        <div class="grc-stay-pills">${stayPills}</div>
        ${stayCard('out', 'Check-out', data.checkOutDate, data.checkOutTime || data.checkOutPolicy)}
      </div>
      <div class="grc-body">
        <div class="grc-grid">
          ${field('Name', data.guestName, 'grc-span-2')}
          ${field('Phone No.', data.phone)}
          ${field('Address', data.address, 'grc-span-2')}
          ${field('Date of Birth', data.dateOfBirth)}
          ${field('City', data.city)}
          ${field('Country', data.country)}
          ${field('Nationality', data.nationality)}
          ${field('Identity', data.identity, 'grc-span-2')}
          ${field('Purpose of Visit', data.purposeOfVisit)}
          ${field('Arrival Date / Time', data.arrivalDateTime)}
          ${field('Departure Date / Time', data.departureDateTime)}
          ${field('Email', data.email)}
          ${field('Coming From', data.comingFrom)}
          ${field('Next Destination', data.nextDestination)}
          ${field('Gender', data.gender)}
        </div>

        <div class="grc-split">
          <div>
            <div class="grc-section">Travel &amp; settlement</div>
            <div class="grc-grid" style="grid-template-columns:1fr 1fr">
              ${field('Mode of Transport', data.modeOfTransport)}
              ${field('Vehicle No.', data.vehicleNo)}
              ${field('Passport No.', data.passportNumber)}
              ${field('Date of Issue', data.passportIssueDate)}
              ${field('Place of Issue', data.passportIssuePlace)}
              ${field('Arrival in India', data.arrivedInCountryOn)}
            </div>
            <div class="grc-field" style="margin-top:10px">
              <span class="grc-label">Settlement of my bill by</span>
              <div class="grc-checks">
                ${(data.settlementMethods || []).map((method) => checkbox(method.label, method.checked)).join('')}
              </div>
            </div>
            ${data.formC ? `<div style="margin-top:4px">${field('Form C', data.formC)}</div>` : ''}
          </div>
          <div>
            <table class="grc-pay">
              <thead>
                <tr><th colspan="2">Booking Payment Info</th></tr>
              </thead>
              <tbody>
                ${payRow('Booking Charges', data.bookingCharges)}
                ${data.discountAmount ? payRow('Discount', data.discountAmount) : ''}
                ${data.extraCharges ? payRow('Extra Charges', data.extraCharges) : ''}
                ${payRow('Total Tax', data.totalTax)}
                ${payRow('Total Amount', data.totalAmount, { strong: true })}
                ${payRow('Amount Paid', data.amountPaid)}
                ${payRow('Balance', data.balance, { strong: true })}
              </tbody>
            </table>
            <div class="grc-grid" style="grid-template-columns:1fr 1fr;margin-top:4px">
              ${field('Receipt No.', data.receiptNo)}
              ${field('Receipt Date', data.receiptDate)}
            </div>
          </div>
        </div>

        <div class="grc-grow"></div>
        <div class="grc-bottom">
          <div class="grc-policy">
            <div class="grc-policy-copy">
              <div class="grc-policy-times">
                Check-in ${escapeHtml(data.checkInPolicy)} &nbsp;|&nbsp; Check-out ${escapeHtml(data.checkOutPolicy)}
              </div>
              <p class="grc-note">
                The Management will not be held responsible for the loss or theft of any valuables or cash.
                All valuables and cash should be deposited with the Front Office Cashier before leaving the hotel premises.
                Early check-in or late check-out will be charged as per hotel policy.
              </p>
            </div>
            <div class="grc-sign">
              <span class="grc-label">Guest signature</span>
              <span class="grc-blank"></span>
            </div>
          </div>

          <div class="grc-footer">
            <div class="grc-sig-line">Front Office Assistant</div>
            <div class="grc-sig-line" style="text-align:right">Front Office Manager</div>
          </div>
          ${data.printedOn ? `<div class="grc-fine"><span></span><span>Printed ${escapeHtml(data.printedOn)}</span></div>` : ''}
        </div>
      </div>
    </article>
  `;
}

export function ensureGuestRegistrationCardStyles(doc = document) {
  if (doc.getElementById(GRC_STYLE_ID)) return;
  const style = doc.createElement('style');
  style.id = GRC_STYLE_ID;
  style.textContent = getGuestRegistrationCardStyles();
  doc.head.appendChild(style);
}

export function fitGuestRegistrationCardToPage(doc = document) {
  const page = doc.querySelector('.grc-page') || doc.body;
  const sheet = doc.querySelector('.grc-sheet');
  if (!page || !sheet) return;
  sheet.style.transform = 'none';
  sheet.style.width = '100%';
  sheet.style.height = '100%';
  const avail = page.clientHeight;
  const used = sheet.scrollHeight;
  if (avail > 0 && used > avail + 1) {
    const scale = avail / used;
    sheet.style.transformOrigin = 'top left';
    sheet.style.transform = `scale(${scale})`;
    sheet.style.width = `${100 / scale}%`;
  }
}

export function buildGuestRegistrationCardDocument(data = {}) {
  return `<!DOCTYPE html>
<html class="grc-print-root">
  <head>
    <meta charset="UTF-8" />
    <title>Guest Registration Card - ${escapeHtml(data.grCardNo || data.guestName || 'GRC')}</title>
    <style>
      @page { size: A4 portrait; margin: 0; }
      html, body { margin: 0; padding: 0; background: #fffdf8; }
      ${getGuestRegistrationCardStyles()}
    </style>
  </head>
  <body>
    <div class="grc-page">
      ${renderGuestRegistrationCardMarkup(data)}
    </div>
  </body>
</html>`;
}
